"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Text = _typography.default.Text;
var RowItem = function RowItem(_ref) {
  var recordWidth = _ref.recordWidth,
    title = _ref.title,
    body = _ref.body;
  return /*#__PURE__*/_react.default.createElement(_col.default, {
    className: "mb-1",
    xs: recordWidth,
    sm: recordWidth,
    md: recordWidth,
    lg: 12,
    xl: 12
  }, /*#__PURE__*/_react.default.createElement(Text, {
    className: "label-small-medium"
  }, title), /*#__PURE__*/_react.default.createElement(Text, null, body));
};
RowItem.propTypes = {
  recordWidth: _propTypes.default.number,
  title: _propTypes.default.string,
  body: _propTypes.default.any
};
var _default = RowItem;
exports.default = _default;